const About = () => (
  <section id="about" className="bg-[#3a3a3a] py-16">
    <div className="content">
      <h2 className="text-4xl md:text-5xl font-bold text-[#FFD700] mb-6">Why Choose B & G Fitness?</h2>
      <div className="flex flex-wrap gap-8">
        <div className="flex-1 min-w-[280px] p-4">
          <h3 className="text-2xl font-semibold text-[#32cd32] mb-3">Our Mission</h3>
          <p className="text-[#e0e0e0] text-base">We’re here to make fitness epic for everyone in Tarboro. With state-of-the-art gear and trainers who bring the heat, we’ll help you smash your goals.</p>
          <div className="bg-[#32cd32] text-white p-4 rounded-lg mt-4 text-center">
            <p className="font-medium">Over 500 members strong!</p>
          </div>
        </div>
        <div className="flex-1 min-w-[280px] p-4">
          <h3 className="text-2xl font-semibold text-[#32cd32] mb-3">Our Community</h3>
          <p className="text-[#e0e0e0] text-base">Join a squad that lifts you up. From high-energy classes to late-night gym sessions, we’re all about building strength and connections.</p>
          <div className="bg-[#32cd32] text-white p-4 rounded-lg mt-4 text-center">
            <p className="font-medium">10+ years serving Tarboro!</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default About;